import { InputText } from '@snowball-tech/fractal/dist/src/components/InputText'
import { ScrollArea } from '@snowball-tech/fractal/dist/src/components/ScrollArea'
import { TabContent as FractalTabContent } from '@snowball-tech/fractal/dist/src/components/Tabs'

import { type ChangeEvent, useState } from 'react'

import type { MediaProviderTabContentProps } from '../../../types'

import { AllowedMediaSources } from '../../../enums'
import LoremPicsumGallery from '../../Gallery/LoremPicsumGallery'
import { onGalleryPickHelper } from './helpers'

const provider = AllowedMediaSources.LoremPicsum

export default function LoremPicsum({
  onPick,
  setIsLoading,
}: Omit<MediaProviderTabContentProps, 'type'>) {
  const [page, setPage] = useState(1)
  const updatePage = (
    _event: ChangeEvent<HTMLInputElement>,
    newPage: string,
  ) => {
    setPage(Number.parseInt(newPage, 10))
  }

  return (
    <FractalTabContent className="flex h-full flex-col gap-2" name={provider}>
      <InputText
        fullWidth
        max={34}
        min={1}
        type="number"
        value={page}
        withSpinButton
        onChange={updatePage}
      />

      <ScrollArea>
        <LoremPicsumGallery
          page={page}
          onPick={onGalleryPickHelper(onPick, provider, setIsLoading)}
        />
      </ScrollArea>
    </FractalTabContent>
  )
}
